import 'bootstrap';

import FloatingVue from 'floating-vue';
import moment from "@/modules/moment";
import helper from "@/base/modules/helper";
import http from "@/http";
import S from 'swiper';
import laravelEcho from "@/base/modules/laravel-echo";
import {registerFieldComponents} from '@/global-components/fields';
import {closeModalsOnRouteChange} from '@/base/modules/modalRouteCleanup';
import TheMask from './TheMask.vue';
import Preloader from './Preloader.vue';
import BtnWithLoading from './BtnWithLoading.vue';

export function setupGlobalComponents(app, router) {
    closeModalsOnRouteChange(router);
    app.config.globalProperties.$appConfig = window.appConfig;

    if (window.appConfig.orderStatuses) {
        app.config.globalProperties.$orderStatuses = Object.values(window.appConfig.orderStatuses);
    }

    app.use(FloatingVue);

    app.config.globalProperties.moment = moment;
    app.config.globalProperties.$helper = helper;
    app.config.globalProperties.$http = http;
    app.config.globalProperties.$swiper = S;
    app.config.globalProperties.$laravelEcho = laravelEcho;

    registerFieldComponents(app);

    app.component('TheMask', TheMask);

    app.component('Preloader', Preloader);

    app.component('BtnWithLoading', BtnWithLoading);
}
